import React, { useState, useEffect } from 'react';
import { API } from '../../../constants/api';
import { getGifWidgetModule } from '../../../utils/apiHeader';
import { StyledImg, StyledText, StyledWrapper } from './style';

const GifModule = () => {
  const [data, setData] = useState(undefined);
  useEffect(() => {
    getGifWidgetModule().then(res => {
      setData({
        text: res.title,
        img: `${API}${res.path}`
      });
    });
  }, []);

  return data && data !== {} && data.text ? (
    <StyledWrapper>
      <StyledImg src={`${data.img}`} alt="GIF animado" />
      <StyledText>{data.text}</StyledText>
    </StyledWrapper>
  ) : null;
};

export default GifModule;
